/**
 * Schools List API Contract
 *
 * GET /v1/schools
 * Retrieve a paginated list of schools accessible to the authenticated user.
 */

import { z } from 'zod'
import { PaginationMetaSchema, PaginationParamsSchema } from '../common'
import { SchoolListItemSchema, type SchoolListItem } from '../../schemas/entities/school'

// Re-export the schema and type for consumers that need them directly
export { SchoolListItemSchema, type SchoolListItem }

/**
 * Request Schema
 */
export const SchoolsListRequestSchema = PaginationParamsSchema.extend({
  include_stats: z.boolean().optional().default(false).describe('Include pre-computed school stats')
})

export type SchoolsListRequest = z.infer<typeof SchoolsListRequestSchema>

/**
 * Response Schema
 */
export const SchoolsListResponseSchema = z.object({
  data: z.array(SchoolListItemSchema),
  message: z.string(),
  meta: PaginationMetaSchema
})

export type SchoolsListResponse = z.infer<typeof SchoolsListResponseSchema>
